import React from 'react';
import { getJson } from 'session';
import { Acl } from 'modules/common/components/Acl';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';

const useStartAssessment = (
  isLoading,
  isStarted,
  transactionStatus,
  applicationStatus,
  onYesCallBack,
  onNoCallback = () => {}
) => {
  const permissions = getJson('permissions');
  const isStatusAllowed =
    ['PENDING', 'ONGOING', 'VERIFIED', 'ASSESSED BY PLANNING DEPARTMENT'].indexOf(transactionStatus) > -1;

  const isApplicationStatusAllowed =
    ['PENDING', 'ONGOING', 'VERIFIED', 'ASSESSED BY PLANNING DEPARTMENT'].indexOf(applicationStatus) > -1;

  const isAllowedPerRole = (Acl(permissions, ['EBPLS BPLO - START VERIFY']) && ['ONGOING', 'PENDING'].indexOf(transactionStatus) > -1) ||
    (Acl(permissions, ['EBPLS PLANNING DEPARTMENT - START ASSESSMENT']) && ['ONGOING', 'VERIFIED'].indexOf(transactionStatus) > -1) ||
    (Acl(permissions, ['EBPLS ENGINEERING DEPARTMENT - START ASSESSMENT']) && ['ONGOING', 'ASSESSED BY PLANNING DEPARTMENT'].indexOf(transactionStatus) > -1);

  const isAllowed = true && isStatusAllowed && isApplicationStatusAllowed && (isAllowedPerRole);

  const onStartAssessment = e => {
    e.preventDefault();
    ConfirmAlert(
      `Are you sure, do you want ${isStarted ? 'Stop' : 'Start'} assessment?`,
      onYesCallBack,
      onNoCallback,
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };
  
  const buttonLabel = () => {
    if ((!Acl(permissions, ['EBPLS BPLO - START VERIFY']) && !Acl(permissions, ['EBPLS BPLO - START VERIFY RENEWAL'])) && (Acl(permissions, ['EBPLS PLANNING DEPARTMENT - START ASSESSMENT']) || Acl(permissions, ['EBPLS ENGINEERING DEPARTMENT - START ASSESSMENT']))){
      return `${isStarted ? "Stop" : "Start"} Assessment`
    }
    return `${isStarted ? "Stop" : "Start"} Verification`
  }

  const component = isAllowed ? (
    <div className="mx-2 mb-2">
      <button
        disabled={isLoading}
        onClick={onStartAssessment}
        type="button"
        className={`btn ${
          isStarted ? 'btn-danger' : 'btn-primary cms-bg-color-primary cms-outline-primary    '
        } font-weight-bold`}
      >
        {isLoading && (
          <>
            <i className="fas fa-spinner fa-spin" />
            &nbsp;
          </>
        )}
        {buttonLabel()}{' '}
        <i className={`fas ${isStarted ? 'fa-times' : 'fa-check'}`} />
      </button>
    </div>
  ) : null;

  return {
    isAllowed,
    onStartAssessment,
    component,
  };
};

export default useStartAssessment;
